import { useEffect, useState } from "react";
import useQuery from "../utils/UseQuery";
import { ClipLoader } from "react-spinners";
import { ButtonStyle } from "../utils/Buttons/Buttons";
import { infoMessage } from "../api/errorHandler";
import { ConstructionOutlined } from "@mui/icons-material";
import { TextFieldStyleDummies } from "../utils/TextFieldStyle/TextFieldStyle";
import {
  coreIdCallback,
  canContinue,
  getColorsByCodeId,
  getColorsByExecFlow,
  coreIdCallbackWithToken,
} from "./hyperFlowApi";
import { useHistory } from "react-router-dom";

const HyperFlowCoreIdCallback = () => {
  let history = useHistory();
  //query params
  const query = useQuery();
  const execFlowId = query.get("execFlowId") ?? "error";
  const regId = query.get("registrationId") ?? "error";
  const stepId = query.get("stepId") ?? "error";
  const code = query.get("code") ?? "error";
  const errorQ = query.get("error") ?? "false";
  const token = query.get("token") ?? "error";
  //State selectors

  //local states
  const [bgColor, setBgColor] = useState(["#ffffff", "#ffffff"]);
  const [darkMode, setDarkMode] = useState(true);
  const [loading, setLoading] = useState(false);

  //get colors
  async function getColors() {
    let resp = await getColorsByExecFlow(execFlowId);
    setBgColor([resp.backgroundColor1, resp.backgroundColor2]);
    setDarkMode(resp.darkMode);
  }

  async function coreIdCallbackF() {
    setLoading(true);
    try {
      if (token !== "error") {
        await coreIdCallbackWithToken(regId, execFlowId, stepId, errorQ, token);
      } else {
        await coreIdCallback(regId, execFlowId, stepId, errorQ);
      }
    } catch (e: any) {
      console.log(e);
    }
    await delay(3000);
    history.push("/hyperFlow/continueFlow?code=" + code);
    // setLoading(false);
  }

  function delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  useEffect(() => {
    getColors();
    coreIdCallbackF();
  }, []);

  const customStyle = {
    "--fontColorPrimary": darkMode ? "#ffffff" : "#000000",
  } as React.CSSProperties;
  //Render
  return (
    <div className="hfMaster" style={customStyle}>
      <div
        style={{
          background: `radial-gradient(${bgColor[0]}, ${bgColor[1]})`,
          position: "fixed",
          height: "100%",
          width: "100%",
          overflow: "auto",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "50%",
            transform: "translate(-50%, -50%)",
            left: "50%",
          }}
        >
          {loading && (
            <div>
              <h1
                className="txt-label-title-hf"
                style={{ fontSize: "22px", marginBottom: "50px" }}
              >
                Espera un momento por favor
              </h1>
              <ClipLoader
                color={darkMode ? "#ffffff" : "#000000"}
                size={"120px"}
                loading={true}
              />
              <h1
                className="txt-label-title-hf"
                style={{ fontSize: "22px", marginBottom: "50px" }}
              >
                Estamos creando tu Identidad Digital
              </h1>
            </div>
          )}

          {!loading && (
            <div>
              <h1
                className="txt-label2"
                style={{ fontSize: "", marginBottom: "50px" }}
              >
                Tu identidad digital ha sido creada
              </h1>
              <h1
                className="txt-label2"
                style={{ fontSize: "", marginBottom: "50px" }}
              >
                Continuemos con tu proceso
              </h1>
              <div
                style={{
                  marginTop: "40px",
                }}
              ></div>
              <ButtonStyle
                onClick={() => {
                  history.push("/hyperFlow/continueFlow?code=" + code);
                }}
                text="Continuar"
                width="177px"
                height="5vh"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HyperFlowCoreIdCallback;
